import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import LegalDocumentContent from '../components/LegalDocumentContent';
import type { LegalDocumentType } from '../services/legalDocuments';
import './LegalPages.css';

interface LegalPageProps {
  documentType: LegalDocumentType;
  isLoggedIn: boolean;
  onNavigateToLogin: () => void;
  onNavigateToRegister: () => void;
  onNavigateToHome: () => void;
  onLogout: () => void;
  onNavigateToProfile: () => void;
  onNavigateToLocations: () => void;
  onNavigateToMyAnnouncements: () => void;
  onNavigateToCreateProduct: () => void;
  onNavigateToMessages: () => void;
  onNavigateToTerms?: () => void;
  onNavigateToPrivacy?: () => void;
  onNavigateToCookies?: () => void;
  onNavigateToAbout?: () => void;
  onNavigateToContact?: () => void;
}

const LegalPage: React.FC<LegalPageProps> = ({
  documentType,
  isLoggedIn,
  onNavigateToLogin,
  onNavigateToRegister,
  onNavigateToHome,
  onLogout,
  onNavigateToProfile,
  onNavigateToLocations,
  onNavigateToMyAnnouncements,
  onNavigateToCreateProduct,
  onNavigateToMessages,
  onNavigateToTerms,
  onNavigateToPrivacy,
  onNavigateToCookies,
  onNavigateToAbout,
  onNavigateToContact,
}) => {
  return (
    <div className="legal-page">
      <Header
        isLoggedIn={isLoggedIn}
        onNavigateToLogin={onNavigateToLogin}
        onNavigateToRegister={onNavigateToRegister}
        onNavigateToHome={onNavigateToHome}
        onLogout={onLogout}
        onProfileClick={onNavigateToProfile}
        onLocationsClick={onNavigateToLocations}
        onAnnouncementsClick={onNavigateToMyAnnouncements}
        onNavigateToCreateProduct={onNavigateToCreateProduct}
        onMessagesClick={onNavigateToMessages}
      />
      <div className="legal-content">
        <BackButton className="legal-back-button" onClick={() => window.history.back()} />
        <div className="legal-container">
          <LegalDocumentContent documentType={documentType} />
        </div>
      </div>
      <Footer
        onNavigateToTerms={onNavigateToTerms}
        onNavigateToPrivacy={onNavigateToPrivacy}
        onNavigateToCookies={onNavigateToCookies}
        onNavigateToAbout={onNavigateToAbout}
        onNavigateToContact={onNavigateToContact}
      />
    </div>
  );
};

export default LegalPage;
